(function () {
  var fallbackMappings = {
    'table-basse-90cm': { variantId: '63797869183325', imageName: 'TABLE_BASSE_90_VIOLET_VERT.jpg', imageUrl: '/cdn/shop/files/TABLE_BASSE_90_VIOLET_VERT.jpg', alt: 'Table basse 90 cm - structure violette et plateau vert' },
    'table-basse': { variantId: '63747125739869', imageName: 'TABLE_BISTRO_JAUNE_VIOLET.jpg', imageUrl: '/cdn/shop/files/TABLE_BISTRO_JAUNE_VIOLET.jpg', alt: 'Table bistro - structure jaune et plateau violet' },
    'table-ronde': { variantId: '63747045818717', imageName: 'TABLE_RONDE_KAKI_BEIGE.png', imageUrl: '/cdn/shop/files/TABLE_RONDE_KAKI_BEIGE.png', alt: 'Table ronde - structure kaki et plateau beige' },
    'fauteuil-2026': { variantId: '', imageName: 'FAUTEUIL_VIOLET_VERT.jpg', imageUrl: '/cdn/shop/files/FAUTEUIL_VIOLET_VERT.jpg', alt: 'Fauteuil Collection 2026 - aubergine et vert' }
  };
  var fallbackPatereMappings = {
    '63735990813021': { imageName: 'PATERE_JAUNE_VIOLET.jpg', imageUrl: '/cdn/shop/files/PATERE_JAUNE_VIOLET.jpg', alt: 'Jaune + violet' },
    '63735991009629': { imageName: 'PATERE_BLEU_CIEL_ORANGE.jpg', imageUrl: '/cdn/shop/files/PATERE_BLEU_CIEL_ORANGE.jpg', alt: 'Bleu ciel + orange' },
    '63735990780253': { imageName: 'PATERE_AMANDE_ROSE.jpg', imageUrl: '/cdn/shop/files/PATERE_AMANDE_ROSE.jpg', alt: 'Amande + rose' },
    '63735991042397': { imageName: 'PATERE_VIOLET_VERT.jpg', imageUrl: '/cdn/shop/files/PATERE_VIOLET_VERT.jpg', alt: 'Violet + vert' }
  };
  var mappings = Object.assign({}, fallbackMappings, window.LBD_HERO_VARIANTS || {});
  var patereMappings = Object.assign({}, fallbackPatereMappings, window.LBD_PATERE_VARIANTS || {});
  var scheduled = false;

  function productHandle(url) {
    try {
      var path = new URL(url, window.location.href).pathname;
      return path.indexOf('/products/') === -1 ? '' : path.split('/products/')[1].split('/')[0];
    } catch (_error) {
      return '';
    }
  }

  function updateLink(link, mapping) {
    if (!mapping.variantId) return;
    var url = new URL(link.href, window.location.href);
    url.searchParams.set('variant', mapping.variantId);
    link.href = url.toString();
  }

  function updateImage(image, mapping) {
    if (!image || !mapping.imageUrl) return;
    if ((image.currentSrc || image.src).indexOf(mapping.imageName) === -1) image.src = mapping.imageUrl;
    image.alt = mapping.alt;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    var picture = image.closest('picture');
    if (picture) {
      Array.prototype.forEach.call(picture.querySelectorAll('source'), function (source) {
        source.removeAttribute('srcset');
        source.removeAttribute('sizes');
      });
    }
  }

  function sync() {
    scheduled = false;
    var grouped = {};
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="/products/"]'), function (link) {
      var handle = productHandle(link.href);
      if (!mappings[handle]) return;
      if (link.closest('.lbd-patere-card')) return;
      if (!grouped[handle]) grouped[handle] = [];
      grouped[handle].push(link);
    });

    Object.keys(grouped).forEach(function (handle) {
      var mapping = mappings[handle];
      grouped[handle].forEach(function (link) {
        updateLink(link, mapping);
        var card = link.closest('[data-product-id], product-card, .product-card, .card-product, .resource-card');
        var image = (card || link).querySelector('img') || link.querySelector('img');
        updateImage(image, mapping);
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('.lbd-patere-card[href*="variant="]'), function (card) {
      var variantId = new URL(card.href, window.location.href).searchParams.get('variant');
      var mapping = patereMappings[variantId];
      if (!mapping) return;
      updateImage(card.querySelector('img'), mapping);
      var title = card.querySelector('.lbd-patere-card__title');
      if (title) title.textContent = mapping.alt;
      card.setAttribute('aria-label', 'Patère Skoool - ' + mapping.alt);
    });

    if (window.location.pathname.indexOf('/products/') === 0) {
      Array.prototype.forEach.call(document.querySelectorAll('a.button-secondary[href*="/pages/sur-mesure"]'), function (link) {
        link.remove();
      });
      Array.prototype.forEach.call(document.querySelectorAll('a.button-secondary[href*="/products/"][href*="personnalisation"]'), function (link) {
        if (window.location.pathname === '/products/fauteuil-2026') {
          link.remove();
          return;
        }
        link.style.display = 'flex';
        link.style.justifyContent = 'center';
        link.style.marginInline = 'auto';
        link.style.textAlign = 'center';
      });
    }

    if (window.location.pathname === '/collections/chaises' && !document.querySelector('.lbd-fauteuil-entry')) {
      var grid = document.querySelector('#ResultsList');
      var list = grid && grid.querySelector('.product-grid');
      var fauteuil = mappings['fauteuil-2026'];
      if (list && fauteuil && fauteuil.imageUrl) {
        var item = document.createElement('li');
        item.className = 'product-grid__item lbd-fauteuil-entry';
        item.innerHTML = '<a class="lbd-fauteuil-entry__link" href="/products/fauteuil-2026">' +
          '<div class="lbd-fauteuil-entry__media"><img src="' + fauteuil.imageUrl + '" alt="' + fauteuil.alt + '" loading="lazy"></div>' +
          '<div class="lbd-fauteuil-entry__title"><p role="heading" aria-level="3">Fauteuil</p></div>' +
          '<div class="lbd-fauteuil-entry__price">€880,00</div></a>';
        list.append(item);
        if (!document.getElementById('lbd-fauteuil-entry-style')) {
          var fauteuilStyle = document.createElement('style');
          fauteuilStyle.id = 'lbd-fauteuil-entry-style';
          fauteuilStyle.textContent = '.lbd-fauteuil-entry__link{display:flex;flex-direction:column;gap:4px;color:inherit;text-decoration:none}.lbd-fauteuil-entry__media{width:100%;aspect-ratio:1/1;overflow:hidden;background:#f7f7f7}.lbd-fauteuil-entry__media img{display:block;width:100%;height:100%;object-fit:cover}.lbd-fauteuil-entry__title{padding-top:4px}.lbd-fauteuil-entry__title p,.lbd-fauteuil-entry__price{margin:0;font-size:13px;font-weight:400;line-height:16.9px}';
          document.head.appendChild(fauteuilStyle);
        }
        var count = document.querySelector('#ResultsList') && document.querySelector('#ResultsList').parentElement.querySelector('[class*="count"], [data-testid*="count"]');
        if (count && /3\s*articles/i.test(count.textContent)) count.textContent = count.textContent.replace(/3\s*articles/i, '4 articles');
      }
    }

    enhanceDesktopMenu();
  }

  function enhanceDesktopMenu() {
    var submenus = document.querySelectorAll('.menu-list__submenu');
    if (!submenus.length) return;
    document.documentElement.dataset.lbdMenuEnhanced = 'true';
    var collectionImages = {
      '/collections/tabourets': '/cdn/shop/files/TABOURET_ROSE_CLAIR_ROUGE.jpg',
      '/collections/chaises': '/cdn/shop/files/CHAISE_BLEU_CIEL_INCOLORE.jpg',
      '/collections/bancs': '/cdn/shop/files/BANC_90_FREEDOM_menu.jpg',
      '/collections/tables': '/cdn/shop/files/TABLE_BASSE_90_AMANDE_ROSE.jpg',
      '/collections/pateres-skoool': '/cdn/shop/files/PATERE_JAUNE_VIOLET.jpg',
      '/collections/boutons-de-tiroir': '/cdn/shop/files/ROSE_JAUNE_AMANDE_856470f4-f7ca-4891-b2db-1ed798c85fd7.jpg'
    };
    submenus.forEach(function (submenu) {
      submenu.classList.add('lbd-menu-images');
      submenu.querySelectorAll('a[href*="/collections/"]').forEach(function (link) {
        var path = new URL(link.href, location.href).pathname.replace(/\/$/, '');
        var imageUrl = collectionImages[path];
        if (!imageUrl || link.querySelector('.lbd-menu-image')) return;
        var image = document.createElement('img');
        image.className = 'lbd-menu-image';
        image.src = imageUrl;
        image.alt = '';
        image.loading = 'eager';
        link.prepend(image);
      });
    });
    if (!document.getElementById('lbd-menu-images-style')) {
      var style = document.createElement('style');
      style.id = 'lbd-menu-images-style';
      style.textContent = '@media (min-width:750px){.lbd-menu-images .mega-menu__list,.lbd-menu-images .mega-menu__column{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:18px!important}.lbd-menu-images .mega-menu__column{grid-column:1/-1!important}.lbd-menu-images li,.lbd-menu-images li>div{min-width:0!important}.lbd-menu-images a{display:flex!important;flex-direction:column!important;gap:8px!important}.lbd-menu-image{display:block!important;width:100%!important;aspect-ratio:1/1!important;object-fit:cover!important;border-radius:0!important}}@media (min-width:1200px){.lbd-menu-images .mega-menu__list,.lbd-menu-images .mega-menu__column{grid-template-columns:repeat(6,minmax(0,1fr))!important}}';
      document.head.appendChild(style);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
